import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import css_248z from './dynamic-media.scss.js';

class DynamicMedia extends s {
    render() {
        return $ `<div style="width:100%;height:100%"><slot name="pics"></slot></div>`;
    }
}
DynamicMedia.styles = css_248z;
customElements.define('dynamic-media', DynamicMedia);

export { DynamicMedia };
